/**
 * Copyright IBM Corp. 2022, 2026
 */

import type { SupportedLocale } from '../types'

export const DEFAULT_LOCALE = 'en'

export const LOCALE_LANGUAGE_MAP = {
	en: 'English',
	fr: 'Français',
	de: 'Deutsch',
	ja: '日本語',
	ko: '한국어',
	pt: 'Português',
	es: 'Español',
	id: 'Bahasa Indonesia',
	zh: '中文',
	it: 'Italiano',
	ar: 'العربية',
}

export const SUPPORTED_LOCALES = Object.keys(
	LOCALE_LANGUAGE_MAP,
) as SupportedLocale[]
